/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Ios_BodyInputs */



/**
* | output |
* | --- |
* | "To get notifications on iPhone or iPad, install the app first: tap the Share button, then “Add to Home Screen.”" |
*
* @param {Notifications_Ios_BodyInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const notifications_ios_body = /** @type {((inputs?: Notifications_Ios_BodyInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Ios_BodyInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Pour recevoir des notifications sur iPhone ou iPad, installez d’abord l’appli : appuyez sur le bouton Partager, puis sur « Ajouter à l’écran d’accueil ».")
	if (locale === "es") return /** @type {LocalizedString} */ ("Para recibir notificaciones en iPhone o iPad, instale primero la aplicación: pulse el botón Compartir y luego «Añadir a pantalla de inicio».")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Para receber notificações no iPhone ou iPad, instale o app primeiro: toque no botão Compartilhar e depois em “Adicionar à Tela Inicial”.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Per ricevere notifiche su iPhone o iPad, installa prima l’app: tocca il pulsante Condividi, poi «Aggiungi alla schermata Home».")
	return /** @type {LocalizedString} */ ("To get notifications on iPhone or iPad, install the app first: tap the Share button, then “Add to Home Screen.”")
});